angular.module('bmsApp.settings').factory('NotificationTemplateSvc', function ($http, $log, $window, $q, CRUDSvc) {

	return {
		read: function () {
			return CRUDSvc.get('api/settings/notification-templates/read');
		},
		save: function (params) {
			return CRUDSvc.post('api/settings/notification-templates/save', params);
		}
	}

});

